// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require(44);
var enumBugKeys = require(15);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};
